module.exports = __webpack_public_path__ + "img/opps.6db7e3ba.png";